import type { TravelConfig } from '../config/TravelConfig';
import type { WorldInfo } from '../config/WorldConfig';
import type { PathfindingRequest } from '../workers/pathfinding.types';
import type { TravelHex } from './TravelTypes';
import { TravelMode } from './TravelTypes';

/**
 * Builds the PathfindingRequest from travel config and world info.
 * Extracted to keep TravelSystem under 200 lines.
 */
export function buildPathfindingRequest(
  start: TravelHex,
  end: TravelHex,
  mode: TravelMode,
  config: TravelConfig,
  worldInfo: WorldInfo,
  sunKeys: number[],
): PathfindingRequest {
  const pf = config.pathfinding;
  const wc = config.warp;
  return {
    type: 'find-path',
    start: { q: start.q, r: start.r },
    end: { q: end.q, r: end.r },
    mode: mode === TravelMode.Warp ? 'warp' : 'normal',
    worldWidthHexes: worldInfo.worldWidthHexes,
    worldHeightHexes: worldInfo.worldHeightHexes,
    sunKeys,
    strategy: pf.strategy,
    corridorWidth: pf.corridorWidth,
    deviationPenalty: pf.deviationPenalty,
    maxNodes: pf.maxNodes,
    warpWarmup: wc.warmupHops,
    warpHops: wc.warpHops,
    warpCooldown: wc.cooldownHops,
    minSafeDistance: wc.minSafeDistance,
  };
}
